<template>
    <div class="cs">
      <yd-cell-group class="invoice_status">
      <p style="padding-left: .24rem;">发票状态</p>
        <yd-cell-item>
          <span slot="left">创建时间</span>
          <span slot="right">{{invoice.created_at}}</span>
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left">状态</span>
          <span slot="right">{{invoice.status_name}}</span>
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left" v-if="invoice.type === 2 && invoice.status === '10'">电子发票：<a :href="invoice.download_file">下载</a></span>
          <span class="change_invoice" slot="right" v-if="invoice.status === '9'"><a :href="'/' + params.id + '/invoice-update/' + invoice.id">修改发票</a></span>
        </yd-cell-item>
      </yd-cell-group>

      <yd-cell-group>
        <p style="padding-left: .24rem;">发票基本信息</p>
        <yd-cell-item>
          <span slot="left">类型</span>
          <span slot="right">{{invoice.type_name}}</span>
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left">发票内容</span>
          <span slot="right">{{invoice.content_name}}</span>
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left">发票主体</span>
          <span slot="right">{{invoice.leixing_name}}</span>
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left">发票抬头</span>
          <span slot="right">{{invoice.name}}</span>
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left">纳税人号</span>
          <span slot="right">{{invoice.shuino}}</span>
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left">邮箱</span>
          <span slot="right">{{invoice.email}}</span>
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left">单位地址</span>
          <span slot="right">{{invoice.zzaddress}}</span>
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left">电话号码</span>
          <span slot="right">{{invoice.zzphone}}</span>
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left">开户银行</span>
          <span slot="right">{{invoice.zzbank}}</span>
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left">银行账户</span>
          <span slot="right">{{invoice.zzaccount}}</span>
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left">开票时间</span>
          <span slot="right">{{invoice.kaipiaotime}}</span>
        </yd-cell-item>

        <yd-cell-item>
          <span slot="left">是否邮寄</span>
          <span slot="right">{{invoice.needmail === '1' ? '是' : '否'}}</span>
        </yd-cell-item>

        <yd-cell-item>
          <span slot="left">收票人姓名</span>
          <span slot="right">{{invoice.lxr}}</span>
        </yd-cell-item>

        <yd-cell-item>
          <span slot="left">手机</span>
          <span slot="right">{{invoice.mobile}}</span>
        </yd-cell-item>

        <yd-cell-item>
          <span slot="left">省市区</span>
          <span slot="right">{{ invoice.province_name }}{{ invoice.city_name}}{{invoice.dist_name }}</span>
        </yd-cell-item>

        <yd-cell-item>
          <span slot="left">详细地址</span>
          <span slot="right">{{invoice.address}}</span>
        </yd-cell-item>
      </yd-cell-group>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'InvoiceDetail',
  data () {
    return {
      invoice: {
        id: '',
        orderid: '',
        created_at: '',
        type: '',
        name: '',
        leixing: '',
        shuino: '',
        status: '',
        business_id: '',
        lxr: '',
        mobile: '',
        email: '',
        province: '',
        city: '',
        dist: '',
        address: '',
        sign: '',
        zzaddress: '',
        zzphone: '',
        zzbank: '',
        zzaccount: '',
        cess: '',
        goodnum: '',
        file: '',
        qrcode: '',
        wxcode: '',
        kaipiaotime: '',
        remark: '',
        bianhao: '',
        email_status: '',
        sms_status: '',
        ismail: '',
        needmail: '',
        wuliucomp: '',
        wuliunum: '',
        wuliuposttime: '',
        wuliuremark: '',
        updated_at: '',
        content: '',
        way: '',
        type_name: '',
        status_name: '',
        leixing_name: '',
        province_name: '',
        city_name: '',
        dist_name: '',
        download_file: '',
        way_name: '',
        fairid: '',
        product_type: '',
        youdi: '',
        way_open: '',
        content_name: ''
      },
      token: this.$store.state.token,
      params: this.$route.params
    }
  },
  methods: {
    getIncoice () {
      let data = {
        invid: this.params.invid
      }
      let that = this
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.token
      axios
        .post('/fair/invoview', data)
        .then(res => {
          res = res.data
          if (res.status) {
            this.invoice = res.data
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    checkLogin () {
      if (!this.$store.state.uid) {
        this.$router.push({path: '/' + this.params.id + '/single-my'})
      }
    }
  },
  mounted () {
    this.checkLogin()
    this.getIncoice()
  }
}
</script>

<style lang="stylus" scoped>
  .cs
    color: #333
    background-color: #FFFFFF
    border-top-left-radius: .2rem
    border-top-right-radius: .2rem
    padding: .2rem
    margin-top: .2rem
  .cs>:first-child
    margin: 0!important
  .cs>:last-child
    margin: 0!important
  .yd-cell-item
    padding-right: .24rem
  .yd-cell-item>:last-child
    padding-right: 0
  p::before
    content: ""
    width: .06rem
    height: .32rem
    background-color: #00c800
    position: absolute
    left: 0
    top: 0
    margin-top: .04rem
  .yd-cell-item:not(:last-child):after
    width: calc(100% - 0.48rem)
  .change_invoice a
    background-color: #00C800
    padding: .1rem .2rem
    border-radius: .06rem
    color: #fff
</style>



// WEBPACK FOOTER //
// src/views/template1/InvoiceDetail.vue